import React, { useState, useEffect } from 'react';
import AutocompleteTextarea from '../intake/AutocompleteTextarea';

const PrefilledTextareaStep = ({ question, value, onAnswer, onNext, prefilledValue, userName }) => {
  const [inputValue, setInputValue] = useState(value || prefilledValue || '');
  
  // Update input when prefilled value changes
  useEffect(() => {
    if (!value && prefilledValue) {
      setInputValue(prefilledValue);
    }
  }, [prefilledValue, value]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onAnswer(inputValue);
    onNext();
  };
  
  // Format question with user name
  const formatQuestion = (questionText) => {
    if (userName && questionText.includes("for '")) {
      // This is for questions that have placeholders for user data
      return questionText;
    }
    return questionText;
  };
  
  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {formatQuestion(question.question)}
      </h2>
      
      {/* Pre-filled indicator */}
      {prefilledValue && (
        <div className="flex items-center justify-center gap-2 mb-4">
          <svg className="w-4 h-4 text-[#2d8a5f]" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          <span className="text-sm text-[#2d8a5f]">Pre-filled from your records - you can edit if needed</span>
        </div>
      )}
      
      {/* Subtitle */}
      {question.subtitle && (
        <p className="text-center text-gray-500 mb-6">
          {question.subtitle}
        </p>
      )}
      
      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <AutocompleteTextarea
            question={question}
            value={inputValue}
            onChange={setInputValue}
            required={question.required || false}
          />
        </div>
        
        <button
          type="submit"
          className="btn-primary"
          data-testid="continue-button"
        >
          Continue
        </button>
      </form>
    </div>
  );
};

export default PrefilledTextareaStep;
